import randomString from './randomString'

const getTempUserShortId = () => {
	let tempUserShortId = localStorage.getItem('tempUserShortId')
	if (tempUserShortId === null) {
		tempUserShortId = randomString(4)
		localStorage.setItem('tempUserShortId', tempUserShortId)
	}
	return tempUserShortId
}

export default getTempUserShortId
